import React, { createContext, useEffect, useState } from "react";
import {
  collection,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

export const JobsContext = createContext();

export const JobsProvider = ({ children }) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const jobsRef = collection(db, "jobs");

  // ===============================
  // 🔹 SLUG GENERATOR
  // ===============================
  const createSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-");
  };

  // ===============================
  // 🔹 FETCH ALL JOBS
  // ===============================
  const fetchJobs = async () => {
    setLoading(true);
    try {
      const snapshot = await getDocs(jobsRef);
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setJobs(data);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    } finally {
      setLoading(false);
    }
  };

  // ===============================
  // 🔹 ADD JOB (USING SLUG ID)
  // ===============================
  const addJob = async (jobData) => {
    try {
      const slug = createSlug(jobData.title);

      const cleanedData = {
        ...jobData,
        slug,
        responsibilities: (jobData.responsibilities || []).filter(
          (item) => item && item.trim() !== ""
        ),
        requirements: (jobData.requirements || []).filter(
          (item) => item && item.trim() !== ""
        ),
        createdAt: serverTimestamp(),
      };

      const jobDocRef = doc(db, "jobs", slug); // 👈 SLUG AS ID
      await setDoc(jobDocRef, cleanedData);

      fetchJobs();
    } catch (error) {
      console.error("Error adding job:", error);
    }
  };

  // ===============================
  // 🔹 UPDATE JOB
  // ===============================
  const updateJob = async (jobData) => {
    try {
      const jobDoc = doc(db, "jobs", jobData.slug); // 👈 SLUG AS ID

      const cleanedData = {
        ...jobData,
        responsibilities: (jobData.responsibilities || []).filter(
          (item) => item && item.trim() !== ""
        ),
        requirements: (jobData.requirements || []).filter(
          (item) => item && item.trim() !== ""
        ),
        updatedAt: serverTimestamp(),
      };

      await updateDoc(jobDoc, cleanedData);
      fetchJobs();
    } catch (error) {
      console.error("Error updating job:", error);
    }
  };

  // ===============================
  // 🔹 DELETE JOB
  // ===============================
  const deleteJob = async (id) => {
  try {
    const jobDoc = doc(db, "jobs", id);
    await deleteDoc(jobDoc);
    fetchJobs();
  } catch (error) {
    console.error("Error deleting job:", error);
  }
};


  // ===============================
  // 🔹 ON LOAD – FETCH JOBS
  // ===============================
  useEffect(() => {
    console.log("🔥 FETCHING JOBS FROM FIREBASE...");
    fetchJobs();
  }, []);

  useEffect(() => {
    console.log("🔥 Jobs from Firebase:", jobs);
  }, [jobs]);

  return (
    <JobsContext.Provider
      value={{
        jobs,
        loading,
        addJob,
        updateJob,
        deleteJob,
      }}
    >
      {children}
    </JobsContext.Provider>
  );
};
